import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const before = ['You create worksheets, explanations, and assessments separately.', 'Your teaching materials are scattered across folders and files.', 'Abstract chemistry concepts take too long to explain without clear visual support.', 'Every new unit means starting the planning process again.'];
const after = ['Save hours of lesson-preparation time each week.', 'Explain abstract chemistry concepts with clear visual support.', 'Use ready-to-print worksheets, assessments, and answer keys.', 'Keep your lessons consistent across different chemistry units.', 'Adapt the resources for individual practice, group work, review, homework, or assessment.'];
export function PainSection() {
  return <section className="w-full bg-paper px-5 py-12 sm:py-20" data-id="element-136" data-mp="22aj9l11w8gz0">
      <div className="mx-auto max-w-5xl" data-id="element-137" data-mp="278bc0p05zlhg">
        <div className="mx-auto max-w-2xl text-center" data-id="element-138" data-mp="2779p9n9sdajw">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-139" data-mp="3rmr1bpjmi8xs">
            Stop Spending Your Evenings Creating Chemistry Materials From Scratch.
          </h2>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-140" data-mp="5gcaiadwlvug">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5
        }} className="rounded-2xl border-l-4 border-red-300 bg-[#FFF5F5] p-6 sm:p-8" data-id="element-141" data-mp="5dq3qcyu7kda">
            <h3 className="mb-5 text-lg font-bold text-ink sm:text-xl" data-id="element-142" data-mp="33vlm9clibkoj">The Challenge</h3>
            <ul className="space-y-3" data-id="element-143" data-mp="3iofe7xhytta3">
              {before.map(item => <li key={item} className="flex items-start gap-3" data-id="element-144" data-mp="3du1ghoftza29">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-145" data-mp="2q59u5dox9lxe">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-146" data-mp="2l6fbqcuv9zdt" />
                  </span>
                  <span className="text-sm leading-relaxed text-ink/80" data-id="element-147" data-mp="p3alv1nenr5w">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="rounded-2xl border-l-4 border-cobalt bg-[#EEF4FF] p-6 sm:p-8" data-id="element-148" data-mp="yt3mj7m0elvd">
            <h3 className="mb-5 text-lg font-bold text-cobalt-deep sm:text-xl" data-id="element-149" data-mp="b52hw9rybpl8">
              With Visual Chemistry™
            </h3>
            <ul className="space-y-3" data-id="element-150" data-mp="f4bc1fqwlphb">
              {after.map(item => <li key={item} className="flex items-start gap-3" data-id="element-151" data-mp="k5iinbhb8ime">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-152" data-mp="1qlb3ya9ca2at">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-153" data-mp="1viba0l66v51x" />
                  </span>
                  <span className="text-sm leading-relaxed text-ink/80" data-id="element-154" data-mp="25nb7eu5ep8j8">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}